import { EndPointService } from '../api-handlers/axios';

const ROUTE = 'articles/categories';

const list = (params: any) => EndPointService.get(`/${ROUTE}`, params);
const get = (id: number) => EndPointService.get(`/${ROUTE}/${id}`);
const create = (data: any) => EndPointService.post(`/${ROUTE}`, data);
const update = (id: number, data: any) => EndPointService.patch(`/${ROUTE}/${id}`, data);
const remove = (id: number) => EndPointService.delete(`/${ROUTE}/${id}`);

export default {
    list,
    get,
    create,
    update,
    remove,
};
